// if you change a value - also change in dimensions.scss
export const CSS_BREAKPOINTS = {
    mobile: 420,
    tablet: 768,
    smallscreen: 1024,
    laptop: 1366,
    full: 1720,
};
